import "./App.css";
import "./styles/variables.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import {
    Dashboard,
    Home,
    Tickets,
    AddNewTickets,
    ViewTicket,
} from "./imports";
import MyTickets from "./Components/Main/MyTickets/MyTickets";
import Apps from "./pages/Apps";
import Unauthorized from "./pages/Unauthorized";

/**
 * Protected Route Component
 * Redirects to Auth Microservice if not authenticated
 */
function ProtectedRoute({ children }) {
    const { user, loading, redirectToLogin } = useAuth();

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px',
                color: '#6c757d',
            }}>
                Loading...
            </div>
        );
    }

    if (!user) {
        redirectToLogin();
        return null;
    }

    return children;
}

/**
 * Main App Component with Auth Integration
 */
function AppRoutes() {
    return (
        <Router>
            <Routes>
                {/* Protected Routes */}
                <Route
                    path="/"
                    exact
                    element={
                        <ProtectedRoute>
                            <Dashboard mainComponent={<Home />} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/tickets"
                    exact
                    element={
                        <ProtectedRoute>
                            <Dashboard mainComponent={<Tickets />} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/my-tickets"
                    exact
                    element={
                        <ProtectedRoute>
                            <Dashboard mainComponent={<MyTickets />} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/add-new-ticket"
                    exact
                    element={
                        <ProtectedRoute>
                            <Dashboard mainComponent={<AddNewTickets />} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/view-ticket/:id"
                    exact
                    element={
                        <ProtectedRoute>
                            <Dashboard mainComponent={<ViewTicket />} />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/apps"
                    element={
                        <ProtectedRoute>
                            <Apps />
                        </ProtectedRoute>
                    }
                />

                {/* Unauthorized Page */}
                <Route path="/unauthorized" element={<Unauthorized />} />

                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

function App() {
    return (
        <div className="app">
            <AuthProvider>
                <AppRoutes />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        success: {
                            duration: 3000,
                            style: {
                                background: '#3bac75',
                                color: '#fff',
                                padding: '16px',
                                borderRadius: '8px',
                            },
                        },
                        error: {
                            duration: 4000,
                            style: {
                                background: '#dc3545',
                                color: '#fff',
                                padding: '16px',
                                borderRadius: '8px',
                            },
                        },
                    }}
                />
            </AuthProvider>
        </div>
    );
}

export default App;
